import React, { Component } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { connect } from 'react-redux';
import { openFileViewer } from '../../actions';
import LoadingComponent from '../../components/common/LoadingComponent';
import NewBenefitsCard from '../../components/policy/newBenefitsCard';
import { BoldText, Text, SemiBoldText } from '../../components/common/Text';
import NewClaimsCard from '../../components/policy/NewClaimsCard';
import { FadeInTransition } from '../../components/transitions/transitions';
import NewHelpCard from '../../components/policy/NewHelpCard';
import HospitalizationModal from '../../containers/common/HospitalizationModal';
import {
  InsureTabApi,
  InsureTabIpdBenefits,
  InsureTabOpdBenefits,
} from '../../services';
import { Carousel } from 'react-responsive-carousel';
import arrowLeft from '../../images/common/arrow-left.svg';
import Tappable from 'react-tappable/lib/Tappable';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import EyeIcon from '../../images/newInsurerPage/eyeIcon.svg';
import WalletCardBackground1 from '../../images/newInsurerPage/walletBackground1.svg';
import WalletCardBackground2 from '../../images/newInsurerPage/walletBackground2.svg';
import WalletCardBackground3 from '../../images/newInsurerPage/walletBackground3.svg';
import HospitalCardBg from '../../images/newInsurerPage/HospitalCardBg.svg';
import HospitalCardArrow from '../../images/newInsurerPage/hospitalizationCardArrow.svg';
import PurpleDownArrow from '../../images/policy/purpleArrowDown.svg';
import BlueDownArrow from '../../images/policy/blueArrowDown.svg';
import GreenDownArrow from '../../images/policy/greenArrowDown.svg';
import Modal from '../../containers/common/Modal';
import NewHealthBenefitsCard from '../../components/policy/NewHealthBenefitsCard';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  height: 100vh;
  background: #ffffff;
  overflow: hidden;
  @media (min-width: 768px) {
    height: 90vh;
  }
`;

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  background: white;
`;

const Body = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: stretch;
  padding-bottom: 2rem;
  overflow-x: hidden;
`;

const HeaderContainer = styled.div`
  // position: fixed;
  // top: 0px;
  // left: 0px;
  // width: 100%;
  // display: flex;
  // flex-direction: column;
  // padding: 22px 0 18px;
  // align-self: stretch;
  // align-items: center;
  // justify-content: center;
  // border-bottom: 1px solid #f0f3f6;
  // background-color: white;
  // z-index: 9999;

  display: flex;
  flex-direction: column;
  padding: 30px 0 18px;
  align-self: stretch;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #f0f3f6;
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;

const HeaderText = styled(BoldText)`
  font-size: 16px;
  text-align: center;
  font-family: Inter;
  font-weight: 600;
`;
const SectionHeading = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 140%;
  margin-bottom: 1rem;
`;
const Session = styled.div`
  width: 90%;
  margin: auto;
  //margin-top: 1rem;
  //margin-bottom: 1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e6e9ec;
`;
const BackContainer = styled(Tappable)`
  //   margin-right: 0.5rem;

  display: flex;
  width: 44px;
  align-items: center;
  justify-content: center;
  &.Tappable-active {
    opacity: 0.2;
  }
`;

const HeaderTitleContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;

const HospitalizationModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  height: 100vh;
  width: 100vw;
`;

const styledElement = document.getElementsByClassName('carousel-root');

class IpdBenefits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      insured: false,
      opdPolicies: [],
      ipdPolicies: [],
      claims: [],
      opdWalletDetails: [],
      policyDetails: {},
      policySavings: {},
      reimbursementRequests: null,
      coiUrl: null,
      activeTabIndex: 0,
      activeTab: '',
      opdDependentWallet: [],
      dependentSelectedWallet: {},
      opdEcards: [],
      benefits: [],
      claimsSection: [],
      helpSection: [],
      offersSection: [],
      walletSection: [],
      currentOpenCard: null,
      healthBenefits: [],
      cards: [],
      hospitalCard: {},
      eCards: [],
      showHospitalizationModal: false,
      showPendingHospilationBlocker: true,
    };
  }

  Header() {
    return (
      <HeaderContainer>
        <Header>
          <BackContainer onTap={() => this.props.history.goBack()}>
            <img src={arrowLeft} alt="back" />{' '}
          </BackContainer>
          <HeaderText>Ipd Benefits Details</HeaderText>
        </Header>
      </HeaderContainer>
    );
  }
  //   {
  //     <HeaderContainer>
  //             <BackContainer onTap={() => history.push('/home')}>
  //               <img src={arrowLeft} alt="back" />
  //             </BackContainer>
  //             <HeaderTitleContainer>
  //               <HeaderText>Clinic Consultation </HeaderText>
  //             </HeaderTitleContainer>
  //           </HeaderContainer>
  //   }
  getAppropriateRoute(key) {
    //console.log('function is accessed');
    switch (key) {
      case 'opd-policy-1':
        return this.props.history.push('home/insure/opd');
      case 'help':
        return this.props.history.push('/home/insure/faq');
      case 'gmc-policy':
        return;
      default:
        return '';
    }
  }
  hideModal = () => {
    this.setState({
      showRelativeModal: false,
      showHospitalizationModal: false,
    });
  };

  getBackground(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;
    switch (backgroundIndex) {
      case 0:
        return WalletCardBackground1;
      case 1:
        return WalletCardBackground2;
      case 2:
        return WalletCardBackground3;
      default:
        return '';
    }
  }
  getBackgroundColor(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;

    switch (backgroundIndex) {
      case 0:
        return 'linear-gradient(132deg, rgba(249, 126, 124, 0.20) 0%, rgba(255, 109, 162, 0.10) 95.83%)';
      case 1:
        return 'linear-gradient(136deg, #C7EBFF 0%, rgba(211, 237, 255, 0.56) 91.69%)';
      case 2:
        return 'linear-gradient(151deg, rgba(146, 220, 70, 0.20) 0.01%, rgba(232, 228, 110, 0.20) 100%)';
      default:
        return '';
    }
  }
  getArrow(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;
    switch (backgroundIndex) {
      case 0:
        return PurpleDownArrow;
      case 1:
        return BlueDownArrow;
      case 2:
        return GreenDownArrow;
      default:
        return '';
    }
  }
  getTextColor(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;
    switch (backgroundIndex) {
      case 0:
        return '#E16262';
      case 1:
        return '#2E89BD';
      case 2:
        return '#90B529';
      default:
        return '';
    }
  }
  onCardTap(index) {
    if (this.state.currentOpenCard === index) {
      this.setState({ currentOpenCard: null });
    } else {
      this.setState({ currentOpenCard: index });
    }
  }

  renderBody() {
    return (
      <div>
        {this.state && this.state.eCards && this.state.eCards.length > 1 ? (
          <CarouselOuterContainer>
            <Carousel
              showIndicators={true}
              showStatus={false}
              centerMode={true}
              centerSlidePercentage="90"
            >
              {this.state.eCards &&
                this.state.eCards.map((eCard) => {
                  return (
                    <CardDiv key={eCard.age}>
                      <CardHeader>
                        <CardInsurerLogoContainer>
                          <img src={eCard.insurerLogo} />
                        </CardInsurerLogoContainer>
                        <CardTitle>OPD E-Card</CardTitle>
                      </CardHeader>
                      <CardData>
                        <CardPtag>Member Name</CardPtag>

                        <CardPtag2>{eCard.name}</CardPtag2>
                      </CardData>
                      <CardData>
                        <CardPtag>Age</CardPtag>

                        <CardPtag2>{eCard.age}</CardPtag2>
                      </CardData>
                      <CardData>
                        <CardPtag>Policy Number</CardPtag>

                        <CardPtag2>{eCard.policyNumber}</CardPtag2>
                      </CardData>
                      <CardData>
                        <CardPtag>Valid Till</CardPtag>

                        <CardPtag2>{eCard.validTill}</CardPtag2>
                      </CardData>
                      <CardFooter>
                        <CardSponsorLogoContainer>
                          <CardPtag>Corporate Name</CardPtag>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'left',
                            }}
                          >
                            <img
                              src={eCard.sponsorLogo}
                              style={{ width: '55%' }}
                            />
                          </div>
                        </CardSponsorLogoContainer>
                      </CardFooter>
                    </CardDiv>
                  );
                })}
            </Carousel>
          </CarouselOuterContainer>
        ) : (
          <CarouselOuterContainer>
            <Carousel
              showIndicators={false}
              showStatus={false}
              centerMode={true}
              centerSlidePercentage="100"
            >
              {this.state.eCards &&
                this.state.eCards.map((eCard) => {
                  return (
                    <CardDiv key={eCard.age}>
                      <CardHeader>
                        <CardInsurerLogoContainer>
                          <img src={eCard.insurerLogo} />
                        </CardInsurerLogoContainer>
                        <CardTitle>OPD E-Card</CardTitle>
                      </CardHeader>
                      <CardData>
                        <CardPtag>Member Name</CardPtag>

                        <CardPtag2>{eCard.name}</CardPtag2>
                      </CardData>
                      <CardData>
                        <CardPtag>Age</CardPtag>

                        <CardPtag2>{eCard.age}</CardPtag2>
                      </CardData>
                      <CardData>
                        <CardPtag>Policy Number</CardPtag>

                        <CardPtag2>{eCard.policyNumber}</CardPtag2>
                      </CardData>
                      <CardData>
                        <CardPtag>Valid Till</CardPtag>

                        <CardPtag2>{eCard.validTill}</CardPtag2>
                      </CardData>
                      <CardFooter>
                        <CardSponsorLogoContainer>
                          <CardPtag>Corporate Name</CardPtag>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'left',
                            }}
                          >
                            <img
                              src={eCard.sponsorLogo}
                              style={{ width: '55%' }}
                            />
                          </div>
                        </CardSponsorLogoContainer>
                      </CardFooter>
                    </CardDiv>
                  );
                })}
            </Carousel>
          </CarouselOuterContainer>
        )}
        {/* {true && (
          <BenefitsDocLinkContainer>
            <img src={EyeIcon} />
            <CardPtag3>View Benefits Document</CardPtag3>
          </BenefitsDocLinkContainer>
        )} */}
        {this.state && this.state.hospitalCard && (
          <Session>
            <SectionHeading>Health Benefits</SectionHeading>
            <HospitalCardTappable
              onTap={() => this.setState({ showHospitalizationModal: true })}
            >
              <HospitalCard bgColor="#E3E0FF" bgSvg={HospitalCardBg}>
                <HospitalCardWrapper>
                  <HospitalCardTitle>
                    {this.state.hospitalCard.label}
                  </HospitalCardTitle>
                  <HospitalInnerDiv>
                    <HospitalCardDescription>
                      {this.state.hospitalCard.description}
                    </HospitalCardDescription>
                    <HospitalCardButton>
                      <HospitalCardButtonText>
                        <p>Add Request</p> <img src={HospitalCardArrow} />{' '}
                      </HospitalCardButtonText>
                    </HospitalCardButton>
                  </HospitalInnerDiv>
                </HospitalCardWrapper>
              </HospitalCard>
            </HospitalCardTappable>

            {this.state &&
              this.state.benefits &&
              this.state.benefits.map((item) => {
                return (
                  <HospitalCardBenefits style={{ background: '#F5F4FF' }}>
                    <BenefitsImageContainer>
                      <img src={item.icon} />
                    </BenefitsImageContainer>
                    <HospitalBenefitsTitleContainer>
                      <TitleText>{item.title}</TitleText>
                      <DescriptionText>{item.description}</DescriptionText>
                    </HospitalBenefitsTitleContainer>
                  </HospitalCardBenefits>
                );
              })}
          </Session>
        )}
        {this.state && this.state.cards && this.state.cards.langth > 0 && (
          <Session>
            <SectionHeading>Claims</SectionHeading>
            {this.state.cards &&
              this.state.cards.map((item) => {
                if (item.key === 'claims')
                  return item.cards.map((innerItem) => (
                    <NewClaimsCard
                      data={innerItem}
                      onTap={() => this.props.history.push('/claims')}
                    />
                  ));
              })}
          </Session>
        )}
        {this.state && this.state.cards && this.state.cards.langth > 0 && (
          <Session>
            <SectionHeading>Help</SectionHeading>
            {this.state.cards &&
              this.state.cards.map((item) => {
                if (item.key === 'help') {
                  return item.cards.map((innerItem) => (
                    <NewHelpCard
                      data={innerItem}
                      onTap={() => this.getAppropriateRoute(innerItem.themeKey)}
                    />
                  ));
                }
              })}
          </Session>
        )}
        {this.state && this.state.showHospitalizationModal && (
          <Modal>
            <HospitalizationModalContainer
              onClick={() => this.setState({ showHospitalizationModal: false })}
            >
              <FadeInTransition
                in={this.state.showPendingHospilationBlocker}
                timeout={200}
                mountOnEnter
                unmountOnExit
                onExited={this.hideModal}
                appear
              >
                <div
                  ref={(node) => (this.node = node)}
                  className="bg-textbox flex flex-col items-center justify-center rounded-12"
                  style={{ width: '90%', maxWidth: '400px' }}
                >
                  <HospitalizationModal
                    title={'Hospitalization'}
                    method1={'Claim Reimbursement'}
                    tag1={'Get reimbursed for your previous hospitalisation'}
                    method2={'Cashless Initmation Request'}
                    tag2={'Go cashless for your treatment'}
                    history={this.props.history}
                  />
                </div>
              </FadeInTransition>
            </HospitalizationModalContainer>
          </Modal>
        )}
        {/* {true && (
          <Session>
            <SectionHeading>Health Benefits</SectionHeading>
            {this.state.healthBenefits.map((item) => (
              <NewHealthBenefitsCard data={item} />
            ))}
          </Session>
        )} */}
        {/* {
          <Session>
            <SectionHeading>Claims</SectionHeading>
            {this.state.cards &&
              this.state.cards.map((item) => {
                if (item.key === 'claims')
                  return item.cards.map((innerItem) => (
                    <NewClaimsCard data={innerItem} />
                  ));
                else if (item.key === 'help') {
                  return item.cards.map((innerItem) => (
                    <NewHelpCard data={innerItem} />
                  ));
                }
              })}
          </Session>
        } */}
        {/* <div
          style={{
            height: '100px',
            width: '250px',
            // background:
            //   'linear-gradient(132deg, rgba(249, 126, 124, 0.20) 0%, rgba(255, 109, 162, 0.10) 95.83%)',
            background: WalletCardBackground1,
          }}
        >
          <h1>hello world</h1>
        </div> */}

        {/* {this.state.claimsSection.length > 0 && (
          <Session>
            <SectionHeading>Claims</SectionHeading>
            {this.state.claimsSection.map((item) => (
              <NewClaimsCard data={item} />
            ))}
          </Session>
        )}
        {this.state.helpSection.length > 0 && (
          <Session>
            <SectionHeading>Help</SectionHeading>
            {this.state.helpSection.map((item) => (
              <NewHelpCard data={item} />
            ))}
          </Session>
        )} */}
      </div>
    );
  }
  fetchData() {
    const { authToken } = this.props;
    //console.log('this props are', this.props);
    const { state } = this.props.location;
    //console.log('policyId is ', state);
    if (state && state.policyId) {
      InsureTabIpdBenefits(authToken, state.policyId)
        .then((response) => {
          const ipdData = response;
          this.setState({ eCards: ipdData.policyUsers });
          this.setState({ hospitalCard: ipdData.hospitalCard });
          this.setState({ benefits: ipdData.benefits });
          this.setState({ cards: ipdData.cards });
          //console.log('ecards data is ', ipdData.policyUsers);
        })
        .catch((err) => console.log('err is', err))
        .finally(() => this.setState({ loading: false }));
    }
  }

  componentDidMount() {
    if (this.props.loginState !== 'LOGGED_IN' || !this.props.authToken) {
      this.props.history.push('/');
    } else {
      //this.getConsults();
      this.fetchData();
    }

    //const ipdData = this.IpdCardData();

    //this.setState({ opdEcards: opdData.opdPolicies.eCards });
    //this.setState({ walletSection: opdData.opdUniqueWallets[0].walletDetails });
    // this.setState({ healthBenefits: opdData.opdPolicies.healthBenefits });
    // this.setState({ cards: opdData.cards });
    // console.log('ocards is ', opdData.cards);
    // console.log('wallet data ', opdData.opdUniqueWallets[0].walletDetails);
    //this.setState({ loading: false });
    // console.log('healthbenefits are ', opdData.opdPolicies.healthBenefits);
  }
  render() {
    return !this.state.loading ? (
      <OuterContainer>
        {this.Header()}
        <BodyContainer>
          <Body>{this.renderBody()}</Body>
        </BodyContainer>
      </OuterContainer>
    ) : (
      <LoadingComponent />
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  loginState: state.app.loginState,
  profileImage: state.user.profileImage,
  sponsorId: state.user.sponsorId,
  showSubscription: state.app.config.showSubscription,
  showOPD: state.app.config.showOPD,
  insured: state.app.config.insured,
  subscribed: state.app.config.subscribed,
});

const mapDispatchToProps = (dispatch) => ({
  openFileViewer: (content) => dispatch(openFileViewer(content)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IpdBenefits);

const HospitalCardBenefits = styled.div`
  column-gap: 15px;
  display: flex;
  padding: 1rem;
  margin-top: 1rem;
  border-radius: 1rem;
`;
const BenefitsImageContainer = styled.div`
  width: 40px;
`;
const HospitalBenefitsTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const TitleText = styled.p`
  color: var(--primary-text-new, #0f0b28);
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 150%; /* 21px */
`;
const DescriptionText = styled.p`
  color: #717171;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 150%; /* 18px */
  text-transform: capitalize;
`;

const HospitalCardTappable = styled(Tappable)`
  &.Tappable-active {
    opacity: 0.2;
  }
`;
const HospitalCard = styled.div`
  background: ${(props) => `url(${props.bgSvg})`},
    ${(props) => `${props.bgColor}`};
  border-radius: 12px;
  border: 1px solid rgba(113, 79, 255, 0.11);
  display: flex;
  flex-direction: column;
`;
const HospitalCardTitle = styled.div`
  color: #15006b;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */
`;
const HospitalCardWrapper = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  row-gap: 35px;
`;
const HospitalInnerDiv = styled.div`
  display: flex;
  justify-content: space-between;
`;
const HospitalCardDescription = styled.p`
  color: #15006b;
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  width: 200px;
`;
const HospitalCardButton = styled.div`
  display: flex;
  background: white;
  border-radius: 5px;
  width: 100px;
`;
const HospitalCardButtonText = styled.div`
  display: flex;
  color: #15006b;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 15px */
  width: 100%;
  align-items: center;
  justify-content: center;
`;
const CardDiv = styled.div`
  display: flex;
  flex-direction: column;
  border: 2px solid #d9d9d9;
  border-radius: 20px;
  margin-right: 1rem;
  margin-left: 1rem;
`;
const CardHeader = styled.div`
  display: flex;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  justify-content: space-between;
  align-items: center;
  background: #f5f4ff;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
`;
const CardData = styled.div`
  display: flex;
  justify-content: space-between;
  width:85%
  margin:auto;
  padding-top: 1rem;
  padding-bottom: 0.7rem;
  border-bottom: 1px solid #E6E9EC;
  
`;
const CardInsurerLogoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 55px;
  height: 55px;
`;
const CardSponsorLogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  gap: 5px;
  width: 80px;
  //height: 45px;
`;
const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  align-items: center;
  background: #fff;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
`;
const CardTitle = styled.p`
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 140%;
`;
const CardPtag = styled.p`
  display: flex;
  align-items: center;
  color: #666;
  font-family: Inter;
  font-size: 10px;
  font-weight: 500;
  line-height: normal;
`;
const CardPtag2 = styled.p`
  display: flex;
  align-items: center;
  color: #373737;
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
  line-height: 150%;
`;
const CardPtag3 = styled.p`
  display: flex;
  align-items: center;
  color: #373737;
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
  line-height: 150%;
  padding: 0.5rem;
`;
const CarouselOuterContainer = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;
const BenefitsDocLinkContainer = styled.div`
  display: flex;
  width: 90%;
  margin: auto;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  border: 1px solid var(--text-box-card, #e6e9ec);
  background: var(--white, #fff);
`;
const WalletDetailsContainer = styled.div`
  border-radius: 12px;
  border: 1px solid #ebe5ff;
  background: #fff;
`;
const TappableCard = styled(Tappable)`
  &.Tappable-active {
    opacity: 0.2;
  }
`;
const WalletDetailsMain = styled.div`
  padding: 0.5rem;
  display: flex;
  background: ${(props) => `url(${props.bgSvg})`},
    ${(props) => `${props.bgColor}`};
  flex-direction: column;
  border-radius: 10px;
  row-gap: 10px;
  margin: 0.8rem;
`;
const WalletDetailsDoop = styled.div`
  display: flex;
  background: ${(props) => `${props.bgColor}`};
  flex-direction: column;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  row-gap: 5px;
  width: 90%;
  margin: auto;
  padding-top: 0.8rem;
  border-top: 1px solid #e6e6e6;
`;
const ArrowContainerDoop = styled.div`
  display: flex;
  align-self: flex-start;
  color: #ffbb00;
  font-family: Inter;
  font-size: 9px;
  font-weight: 500;
  padding-bottom: 0.5rem;
`;
const WalletDetailsInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const DetailsLeft = styled.p`
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
`;
const DetailsRight = styled.p`
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
`;
const ArrowContainer = styled.div`
  display: flex;
  align-self: flex-end;
`;
const DetailsLeftDoop = styled.p`
  color: #ffbb00;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
`;
const DetailsRightDoop = styled.p`
  color: #ffbb00;
  text-align: right;
  font-family: Inter;
  font-size: 16px;
  font-weight: 800;
`;
const Numerator = styled.span`
  text-align: right;
  font-family: Inter;
  font-size: 14px;
  font-weight: 800;
`;
const Denominator = styled.span`
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
`;

const NumeratorDoop = styled.span`
  color: #ffbb00;
  text-align: right;
  font-family: Inter;
  font-size: 16px;
  font-weight: 800;
`;
const DenominatorDoop = styled.span`
  color: #ffbb00;
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
`;
const SlidingDiv = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(props) => `${props.bgColor}`};
  padding: 0.5rem;
  border-radius: 10px;
  row-gap: 10px;
  margin: 0.8rem;
`;
const SlidingDivCol1 = styled.div`
  display: flex;
  align-self: flex-start;
  font-family: Inter;
`;
const SlidingDivCol2 = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: Inter;
`;
const SlidingInnerDiv = styled.div`
  display: flex;
  gap: 5px;
  font-size: 11px;
  font-family: Inter;
  align-items: center;
`;
const SlidingDivCol3 = styled.div`
  display: flex;
  font-size: 12px;
  align-self: flex-start;
  align-items: center;
  font-family: Inter;
`;
const WalletIcons = styled.img`
  color: red;
`;
